import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { CloseIcon, DesktopWhite, MobileWhite, StanndaloneVRWhite } from "../../Assets/iconshere";
import Tooltip from "@mui/material/Tooltip";
import { useSelector } from "react-redux";
import axios from "axios";
import apiClient from "../../apiClient";

const DownloadMeta = ({ metaPop, setMetaPop }) => {
  const configData = useSelector((state) => state.configSlice);
  const body = document.body;
  if (metaPop) {
    body.classList.add("propopup-active");
  } else {
    body.classList.remove("propopup-active");
  }

  let [launcher, setLauncher] = useState("");
  let [launcherOculus, setLauncherOculus] = useState("");
  let [launcherApk, setLauncherApk] = useState("");

  const handleGetLauncherFiles = async () => {
    try {
      const data = await apiClient.get(`${configData.config.UNO_URL}/api/application/launcher/latest-version/${configData.config.applicationId}`);
      // const { data } = await axios.get(
      //   `${configData.config.UNO_URL}/api/application/launcher/latest-version/${configData.config.applicationId}`
      // );
      setLauncher(data.windows);
      setLauncherApk(data.android);
      setLauncherOculus(data.oculus);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    handleGetLauncherFiles();
  }, []);

  return (
    <>
      <Modal
        centered
        show={metaPop}
        onHide={() => setMetaPop(false)}
        className="PopupModal platmodaltime launchplaymodal downloadlauncher"
        size="xl"
      >
        <Modal.Body className="position-relative p-5 ">
          <img className="meta-bg" src={configData.config.popup_logo} />
          <div className="playmodalmain">
            <div className="playmodalright">
              <div className="row">
                <div className="col-md-6">
                  <div className="download-text">
                    <h2> {configData.config.name}</h2>

                    <p>Download our launcher to access the content across different platforms</p>
                  </div>
                  <div className="playmodal_rightfoot">
                    <div className="diff_lanchers">
                      <>
                        <Tooltip title="Download">
                          <a
                            href={launcher || "#"}
                            onClick={(e) => {
                              if (!launcher) {
                                e.preventDefault();
                              }
                            }}
                            aria-label="Desktop"
                            className="true"
                            title="click to download"
                            data-mui-internal-clone-element="true"
                          >
                            <DesktopWhite />
                            <span className="title">
                              <p>GET IT FOR</p>
                              <h6>DESKTOP</h6>
                            </span>
                          </a>
                        </Tooltip>

                        <Tooltip title="Download">
                          <a
                            href={launcherOculus || "#"}
                            onClick={(e) => {
                              if (!launcherOculus) {
                                e.preventDefault();
                              }
                            }}
                            aria-label="Standalone VR"
                            className="true"
                            title="click to download"
                            data-mui-internal-clone-element="true"
                          >
                            <StanndaloneVRWhite />
                            <span className="title">
                              <p>GET IT FOR</p>
                              <h6>STANDALONE VR</h6>
                            </span>
                          </a>
                        </Tooltip>
                        
                        <Tooltip title="Download">
                          <a
                            href={launcherApk || "#"}
                            onClick={(e) => {
                              if (!launcherApk) {
                                e.preventDefault();
                              }
                            }}
                            aria-label="Mobile"
                            className="true"
                            title="click to download"
                            data-mui-internal-clone-element="true"
                          >
                            <MobileWhite />
                            <span className="title">
                              <p>GET IT FOR</p>
                              <h6>MOBILE</h6>
                            </span>
                          </a>
                        </Tooltip>
                      </>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="pro-detail-box">
            <span className="close-icon" onClick={() => setMetaPop(false)}>
              <CloseIcon />
            </span>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DownloadMeta;
